export const MediaPlanStatus = {
    APPLIED: {
        label: 'Accepted',
        key: 'APPLIED'
    },
    APPROVED: {
        label: 'Launched',
        key: 'APPROVED'
    },
    REVIEW: {
        label: 'Media plan ready to view',
        key: 'REVIEW'
    },
    UPLOADED: {
        label: 'Processing',
        key: 'UPLOADED'
    }
}
